import checkout from "./form4";

const {
  formField4: {
    allocationActivity,
    quarter,
    year,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId
  },
} = checkout;

const initialValues4 = {
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [quarter.name]: "",
  [year.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [allocationActivity.name]: false,
};

export default initialValues4;
